import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableDebugTools } from '@angular/platform-browser';

// USED FOR AOT
import 'lscache';
import 'lodash';

// import { enableDebugTools } from '@angular/platform-browser';
// import { ApplicationRef } from '@angular/core';
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(moduleRef => {
  const appRef = moduleRef.injector.get(ApplicationRef);
  const cmpRef = appRef.components[0];
  enableDebugTools(cmpRef);
}).catch(err => console.error(err));
